import { UserType } from '@lib/firebase';
import { BookingOverview } from '@pages/Booking/Overview';

import { BookingListItem } from '../components/BookingListItem';

export const BookingOverviewVendor = () => {
  return <BookingOverview BookingItem={BookingListItem} userType={UserType.Vendor} />;
};
